// extracted by mini-css-extract-plugin
export default {"listPage":"listPage_SFU3_5O","listPage_custom":"listPage_custom_X8SCFBo","listPage_fullScreen":"listPage_fullScreen_tHT6T_e"};